import React, { useState } from "react";
import "./OurCustomers.css";
import img1 from "../assets/cust-img1.png";
import img2 from "../assets/cust-img2.png";
import img3 from "../assets/cust-img3.png";
import img4 from "../assets/cust-img4.png";
import img5 from "../assets/cust-img5.png";
import img6 from "../assets/cust-img6.png";
import img7 from "../assets/cust-img7.png";
import img8 from "../assets/cust-img8.png";
import img10 from "../assets/cust-img10.png";
import img11 from "../assets/cust-img11.png";
import img12 from "../assets/cust-img12.png";
import img13 from "../assets/cust-img13.png";
import img14 from "../assets/cust-img14.png";
import img15 from "../assets/cust-img15.png";
import img16 from "../assets/cust-img16.png";





const OurCustomers = () => {
    const [activeTab, setActiveTab] = useState("Commercial Vehicles");

    const logos = {
        "Commercial Vehicles": [
    { img: img13, alt: "Allison" },
    { img: img1, alt: "Cummins" },
    { img: img4, alt: "Daimler Truck" },
    { img: img2, alt: "Paccar" },
    { img: img6, alt: "UD Trucks" },
    { img: img3, alt: "Volvo" },
    { img: img5, alt: "ZF" },
],
        "Passenger Vehicle": [
         { img: img8, alt: "Ford" },
         { img: img10, alt: "Hanon Systems" },
         { img: img7, alt: "Hyundai" },
         { img: img12, alt: "Hyundai Mobis" },
         { img: img11, alt: "KIA" },
         { img: img14, alt: "Tata Autocomp" },
    
    
],
        "Two Wheelers": [
            { img: img16, alt: "BMW" },
            { img: img15, alt: "TVS" },
           
           
        ],
    };

    return (
        <>
            <div className="customers-section">
                <h2>Our Customers</h2>
                <div className="cust-underline"></div>
                <p className="cust-tagline">
                    Trusted by Global Mobility Leaders
                </p>



                <div className="tab-buttons">
                    {Object.keys(logos).map((tab) => (
                        <button
                            key={tab}
                            className={activeTab === tab ? "active" : ""}
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab}
                        </button>
                    ))}
                </div>

                <div className="logo-grid">
                    {logos[activeTab].map((logo, index) => (
                        <div className="logo-card" key={index}>
                            <img src={logo.img} alt={logo.alt} />
                        </div>
                    ))}
                </div>
            </div>

           
        </>
    );
};

export default OurCustomers;
